import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';

type Props = {
  open: boolean;
  onClick?: () => void;
  backgroundColor?: string;
  justifyContent?: string;
  children: ReactElement;
};

export const Modal: FC<Props> = ({
  open,
  onClick,
  backgroundColor = 'rgba(0, 0, 0, 0.5)',
  justifyContent = 'top',
  children,
}) => {
  if (!open) return null;

  return (
    <Wrapper
      open={open}
      onClick={onClick}
      backgroundColor={backgroundColor}
      justifyContent={justifyContent}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div<Props>`
  background: ${({ backgroundColor }) => backgroundColor};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent};
`;
